
(function(){
  const LABEL = {'Dog Outfit Collection':['See all 18 dog outfits','dog-outfit-collection'], 'Cat Outfit Collection':['See all 16 cat outfits','cat-outfit-collection'],
    'National Park Collection':['See all national parks','national-park-collection'], 'Dog Portrait Series':['See all dog portrait styles','dog-portrait-series'],
    'Cat Portrait Series':['See all cat portrait styles','cat-portrait-series'], 'Pet Parent Series':['See all pet parent portraits','pet-parent-series'],
    'Couples Series':['See all couples portraits','couples-series'], 'Best Friends Series':['See all best friends styles','best-friends-series'],
    'Home Series':['See all home portraits','home-series'],
    'USA City Collection':['See all USA cities','usa-city-collection'], 'International City Collection':['See all international cities','international-city-collection']};
  if ((window.PK_PAGE || {}).only) return;                         // a section page: no See-all link to itself
  const rows = [...document.querySelectorAll('section.tiles-section:not(.room-break)')];
  const grpOf = sec => sec.querySelector('figure.tile .ds')?.textContent;
  const lastRow = {}; rows.forEach((sec, i) => { lastRow[grpOf(sec)] = i; });
  rows.forEach((sec, i) => {
    const grp = grpOf(sec), L = LABEL[grp];
    if (!L || lastRow[grp] !== i) return;
    const d = document.createElement('div'); d.className = 'see-link';
    d.innerHTML = '<a></a>'; const a = d.firstChild; a.href = '/collections/' + L[1]; a.textContent = L[0] + ' \u2192';
    sec.appendChild(d);
  });
})();
